<p-dialog
  [(visible)]="visible"
  [header]="header"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  (onHide)="onClose()"
  [closable]="(loading$ | async) !== true">
  <div class="flex flex-col">
    {{ body }}
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-start">
      <button
        type="button"
        pButton
        [label]="confirmLabel || ('common.button.apply' | translate)"
        (click)="onConfirm()"
        [loading]="loading$ | async"
        [disabled]="loading$ | async"></button>
      <button
        type="button"
        pButton
        [label]="cancelLabel || ('common.button.cancel' | translate)"
        class="p-button-outlined"
        (click)="onClose()"
        [disabled]="loading$ | async"></button>
    </div>
  </ng-template>

  <ng-template pTemplate="closeicon">
    <div class="p-dialog-header-icon" [title]="closeAlt || ('common.button.cancel' | translate)">
      <i class="fa-regular fa-xmark text-lg text-gray-800"></i>
    </div>
  </ng-template>
</p-dialog>
